/**
 * The two lines a shop pastes into its own website.
 *
 * Lives here rather than next to either caller because there are now
 * two, and they must not drift: the admin hands this to a tenant to
 * copy (``salesChannels/EmbedTask``), and the marketing landing shows
 * the same thing to somebody deciding whether to sign up
 * (``platform-landing/PlatformEmbed``). A marketing page that advertises
 * a snippet the product does not actually generate is the exact shape
 * of promise this repo keeps paying down — so it is one function, not
 * two copies that look alike today.
 *
 * ``origin`` is the shop's own storefront origin, because that is where
 * ``widget.js`` and the configurator are served from; the loader checks
 * ``event.origin`` against it (see ``embed/protocol.ts``).
 */
export function embedSnippet(origin: string, lang: string): string {
  return [
    `<script src="${origin}/widget.js" async></script>`,
    `<div data-forgmatic-embed data-lang="${lang}"></div>`,
  ].join("\n");
}
